<div class="container-fluid">
    <form [formGroup]="inputForm">
        <div formGroupName="inputData">

            <app-akit-header 
                title="formula-editor" 
                [enableSubHeader]="true">

                <div sub-header>
                    <label>Layout</label>
                    <select formControlName="palette" class="form-control">
                        <option value="">Select layout...</option>
                        <option value="author-full">Full</option>
                        <option value="equations">Equations</option>
                        <option value="algebra">Algebra</option>
                        <option value="arithmetic">Basic</option>
                        <option value="chemistry">Chemistry</option>
                        <option value="logic">Logic</option>
                    </select>
                    <div class="sub-header-part">
                        <label>Theme</label>
                        <select formControlName="theme" class="form-control theme-selector">
                            <option *ngFor="let t of themes" [value]="t.id">{{t.name}}</option>
                        </select>
                    </div>
                    <div class="sub-header-part">
                        <label>Language</label>
                        <select formControlName="lang" class="form-control">
                            <option value="">Select layout...</option>
                            <option value="nl">Nederlands</option>
                            <option value="en">English</option>
                        </select>
                    </div>
                </div>
            </app-akit-header>

        </div>
    </form>

    
    <div class="row header-row">
        <div class="col-12 col-lg-6">
            <h1>{{getText('TitleFormulaEditor')}}</h1>
            <span>{{getText('TextFormulaEditor')}}</span>
        </div>
        <div class="col-12 col-lg-6">
            <div>
                <h1>{{getText('Output')}}</h1>
            </div>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-12 col-lg-6">
            <app-akit-formula-editor
                [palette]="palette"
                [_i18n]="_i18n"
                (latexChanged)="latexChanged($event)"
            ></app-akit-formula-editor>
        </div>
        <div class="col-12 col-lg-6">
            <div *ngIf="latex">
                <div class="latex-rendered" [innerHTML]="latexHtml | safeHtml"></div>
                <div class="latex-raw">
                    latex:<br>
                    {{latex}}
                </div>
            </div>
        </div>
    </div>

    <div class="row header-row mt-5">
        <div class="col-12 col-lg-6">
            <h1>{{getText('TitleMathArea')}}</h1>
            <span>{{getText('TextMathArea')}}</span>
        </div>
        <div class="col-12 col-lg-6">
            <div>
                <h1>{{getText('Output')}}</h1>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-12 col-lg-6">
            <app-akit-matharea
                [palette]="palette"
                [_i18n]="_i18n"
                (contentChanged)="contentChanged($event)"
            ></app-akit-matharea>
        </div>
        <div class="col-12 col-lg-6">
            <div *ngIf="content">
                <div class="content-rendered" [innerHTML]="contentHTML | safeHtml" #contentDiv></div>
                <div class="latex-raw mt-3">
                    latex:<br>
                    {{content}}
                </div>
            </div>
        </div>
    </div>

</div>